import { CustomTable } from "@/components/Tables/CustomTable"
import { useCustomQuery } from "@/hooks/useCustomQuery"
import Modal from "@/pages/stores/Model"
import { columns } from "@/pages/stores/Columns"
import { useState } from "react"
import { CrudProvider } from "@/context/crudContext"
import Breadcrumbs from "@/components/Breadcrumbs/Breadcrumbs"

export default function StoreList() {
  const breadcrumbs = [{ label: "Dashboard", url: "/" }, { label: "Supplier" }]
  return (
    <>
      {/* Breadcrumb */}
      <div className="breadcrumb-card">
        <h5>Stores</h5>

        <Breadcrumbs breadcrumbs={breadcrumbs} />
      </div>

      <CrudProvider>
        <TagTable />
      </CrudProvider>
    </>
  )
}

function TagTable() {
  return (
    <>
      <CustomTable
        label="Stores"
        columns={columns}
        addBtn={false}
        view={false}
        showDelete={false}
        apiPath="stores"
      />

      <Modal />
    </>
  )
}
